import { ConfigProvider, App as AntdApp } from "antd";
import React from "react";
import ReactDOM from "react-dom/client";
import { Toaster } from "react-hot-toast";
import App from "./App";
import "./index.css";
import ReactQueryProvider from "./provider/react_query_provider";
import reportWebVitals from "./reportWebVitals";
import { MessageProvider } from "./provider/AntdNotification";
const ThemedApp = () => {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#111827",
          colorInfo: "#111827",
        },
        components: {
          Divider: {
            colorSplit: "#111827",
          },
        },
      }}
    >
      <AntdApp>
        <MessageProvider>
          <App />
        </MessageProvider>
      </AntdApp>
    </ConfigProvider>
  );
};

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <ReactQueryProvider>
      <ThemedApp />
      <Toaster position="top-center" reverseOrder={false} />
    </ReactQueryProvider>
  </React.StrictMode>
);

reportWebVitals();
